export enum ExternalServiceType {
    UBER = 'uber',
    GLOVO = 'glovo',
    DELIVEROO = 'deliveroo',
    JUSTEAT = 'justeat'
}
